import { UserFriendlyError } from "./base_error";

/**
 * maxSizeInBytes
 */

const maxSizeInBytes = 20 * 1024 * 1024;

/**
 * FileUtils
 */

export class FileUtils {
  static validateFileSize(file: File) {
    if (file.size > maxSizeInBytes) {
      throw new UserFriendlyError(`O arquivo excede o tamanho máximo permitido de ${maxSizeInBytes / (1024 * 1024)} MB.`);
    }
  }

  static async readFileAsBase64(file: File | null | undefined): Promise<string | null> {
    return new Promise<string | null>((accept, reject) => {
      const reader = new FileReader();

      if (file === null || file === undefined) {
        accept(null);
        return;
      }

      this.validateFileSize(file);

      reader.onloadend = async () => {
        if (typeof reader.result === 'string') {
          try {
            if (reader.result.includes("data:")) {
              accept(reader.result.split(',')[1]);
            } else {
              accept(reader.result);
            }
          } catch (e: unknown) {
            reject("Falha ao salvar imagem!");
          } finally {

          }
        } else {
          reject("Falha ao salvar imagem!");
        }
      };

      reader.readAsDataURL(file);
    });
  }
}